import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col, Image } from 'react-bootstrap';

import { ProductKit } from '../order-selection/starter-kit-selection/model/ProductKit';
import { useModuleStore } from '../enrollment-process/module-management/model/ModuleStoreHook';
import { MoneyDisplay } from '../order-selection/starter-kit-selection/util-starter-kit/MoneyDisplay';
import './SocialLinkProductCard.scss';

interface KitGridItemProps {
  kit: ProductKit;
  showDetailLink?: boolean;
  customImage?: string;
  newSlMode?: boolean;
  isSubscription?: boolean;
}

export const SocialLinkProductCard = observer<KitGridItemProps>(function KitGridItem({
  kit,
  showDetailLink = true,
  customImage,
  newSlMode = false,
  isSubscription = false
}) {
  const { t } = useTranslation();
  const store = useModuleStore('socialLinkEntry').enrollmentOrderInfo!;
  const getHtml = (text: any) => (text ? text.split('"\r\n\r\n"').toString() : undefined);
  const image = customImage || kit.smallImageUrl;
  return (
    <Col key={kit.itemId} md={3} style={{ marginBottom: '20px' }}>
      {!newSlMode && (
        <>
          <Card>
            <div className={`text-left bg-primary`}>
              <p className="text-white header-card-text m-1">{kit.title}</p>
            </div>

            <Card.Body className="text-center">
              <span>
                <Button variant="link" onClick={() => store.showProductInfo(kit)}>
                  <Image src={image} fluid />
                </Button>
              </span>
              {showDetailLink && (
                <Button variant="link" onClick={() => store.showProductInfo(kit)}>
                  <u>{t('SocialLinkProductCard_Details')}</u>
                </Button>
              )}
            </Card.Body>
          </Card>
          <strong>
            <span className="pr-1">Price: </span>
            <MoneyDisplay price={kit.price} />
          </strong>
        </>
      )}
      {newSlMode && (
        <Card
          className={'sl-product-card ' + (isSubscription ? 'sl-subscription' : '')}
          onClick={() => store.showItemInfo(kit)}
        >
          <div className="sl-product-image">
            <Image src={image} fluid />
          </div>
          <div className="sl-product-info">
            <p className="sl-product-title">{kit.title}</p>
            <p className="sl-product-description" dangerouslySetInnerHTML={{ __html: getHtml(kit.description) }}></p>
            <p className="sl-product-price">
              Price:
              <MoneyDisplay price={kit.price} newSlMode={newSlMode} />
            </p>
          </div>
        </Card>
      )}
    </Col>
  );
});
